import { ToggleInput, ToggleSize } from '@ui/src';
import { PermissionEnum } from '../../../hoc/user-roles/types';
import { RowWithToggleTypes } from './types';

import cn from './styles.module.css';

const RowWithToggle = ({
  onChange,
  onSelectRow,
  isSelectedRow,
  id,
  isCheckedToggle,
  item,
  isEditable,
}: RowWithToggleTypes): React.JSX.Element => (
  <div
    className={`${onSelectRow ? cn.columnRow : cn.permissionColumnRow} ${
      isSelectedRow ? cn.columnRowActive : ''
    }`}
  >
    {onSelectRow && (
      <button
        onClick={() => onSelectRow(id as PermissionEnum)}
        className={`${cn.columnRowLink} ${
          isSelectedRow ? cn.columnRowLinkActive : ''
        }`}
        aria-label="select row"
        type="button"
      />
    )}

    <div
      className={
        onSelectRow ? cn.switchColumnRowWrapper : cn.permissionColumnRowWrapper
      }
    >
      <div className={cn.switchColumnRowTitle}>{item.title}</div>
      {id !== 'SECTION_UNASSIGNED' &&
        id !== 'UNASSIGNED_LIST' &&
        id !== PermissionEnum.OTHER_LIST && (
          <ToggleInput
            className={cn.toggleWrapper}
            size={ToggleSize.MEDIUM}
            name={
              PermissionEnum[id as PermissionEnum]
                ? PermissionEnum[id as PermissionEnum]
                : id
            }
            checked={isCheckedToggle}
            onChange={(e) =>
              onChange(id as PermissionEnum, e.target.checked, item)
            }
            disabled={!isEditable}
          />
        )}
    </div>
    {item.description && (
      <div
        className={cn.switchColumnRowDescription}
      >{`in ${item.description}`}</div>
    )}
  </div>
);

export default RowWithToggle;
